import { FormTemplateModel } from '.'
import { WorkawareBaseClass } from './WorkawareBaseClass'

export class FormTemplateGroupModel extends WorkawareBaseClass {
  _className = 'FormTemplateGroupModel'
  public Name: string = ''
  public Forms: Array<FormTemplateModel> = []
  public Groups: Array<FormTemplateGroupModel> = []
}
